"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import FormButton from "./webflow_modules/Form/components/FormButton";
import FormErrorMessage from "./webflow_modules/Form/components/FormErrorMessage";
import FormForm from "./webflow_modules/Form/components/FormForm";
import FormSelect from "./webflow_modules/Form/components/FormSelect";
import FormSuccessMessage from "./webflow_modules/Form/components/FormSuccessMessage";
import FormTextarea from "./webflow_modules/Form/components/FormTextarea";
import FormTextInput from "./webflow_modules/Form/components/FormTextInput";
import FormWrapper from "./webflow_modules/Form/components/FormWrapper";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";

export function ContactFormContactUsPage({
  communitySelectRuntimeProp = {},
  formEventRuntimeProps = {},
  formRuntimeProps = {},
}) {
  return (
    <FormWrapper
      className={"contact_form_component"}
      {...formEventRuntimeProps}
    >
      <FormForm
        className={"contact_form"}
        data-name={"SRGLiving - Contact Form"}
        id={"wf-form-SRGLiving---Contact-Form"}
        method={"get"}
        name={"wf-form-SRGLiving---Contact-Form"}
        {...formRuntimeProps}
      >
        <Block className={"div-block-36"} tag={"div"}>
          <Block className={"form_field-wrapper"} tag={"div"}>
            <FormTextInput
              autoFocus={false}
              className={"form_input text-color-black"}
              data-name={"Name"}
              disabled={false}
              id={"Name"}
              maxLength={256}
              name={"Name"}
              placeholder={"Name"}
              required={true}
              type={"text"}
            />
          </Block>
          <Block className={"form_field-wrapper"} tag={"div"}>
            <FormTextInput
              autoFocus={false}
              className={"form_input text-color-black"}
              data-name={"Email"}
              disabled={false}
              id={"Email"}
              maxLength={256}
              name={"Email"}
              placeholder={"Email"}
              required={true}
              type={"email"}
            />
          </Block>
        </Block>
        <Block className={"form_field-wrapper"} tag={"div"}>
          <FormSelect
            className={"form_input text-color-black"}
            data-name={"Feedback"}
            id={"Feedback"}
            multiple={false}
            name={"Feedback"}
            options={[
              {
                t: "I have a question/comment about a community",
                v: "I have a question/comment about a community",
              },
              {
                t: "I have a question/comment for Sares-Regis",
                v: "I have a question/comment for Sares-Regis",
              },
              {
                t: "I'm a resident with a question",
                v: "I'm a resident with a question",
              },
            ]}
            required={true}
          />
        </Block>
        <Block className={"form_field-wrapper"} tag={"div"}>
          <FormSelect
            className={"form_input text-color-black"}
            data-name={"Community"}
            id={"Community"}
            multiple={false}
            name={"Community"}
            options={[
              {
                t: "Community",
                v: "",
              },
              {
                t: "First choice",
                v: "First",
              },
              {
                t: "Second choice",
                v: "Second",
              },
              {
                t: "Third choice",
                v: "Third",
              },
            ]}
            required={false}
            {...communitySelectRuntimeProp}
          />
        </Block>
        <Block className={"form_field-wrapper"} tag={"div"}>
          <FormTextarea
            autoFocus={false}
            className={"form_input is-text-area text-color-black"}
            data-name={"Message"}
            id={"Message"}
            maxLength={5000}
            name={"Message"}
            placeholder={"Message"}
            required={true}
          />
        </Block>
        <Block
          className={"margin-top margin-small"}
          id={"w-node-_78eee6cd-23b7-2308-e732-c78eeaa61cee-eaa61ce1"}
          tag={"div"}
        >
          <FormButton
            className={"button"}
            data-wait={"Please wait..."}
            id={"w-node-_78eee6cd-23b7-2308-e732-c78eeaa61cef-eaa61ce1"}
            type={"submit"}
            value={"Submit"}
          />
        </Block>
        <HtmlEmbed
          content={
            '<input type="hidden" name="form-name" value="contact">\n<input type="hidden" name="bot-field" value="">'
          }
          id={"w-node-c35b2736-de69-53e5-9803-7adf37be0566-eaa61ce1"}
        />
      </FormForm>
      <FormSuccessMessage className={"success-message"} />
      <FormErrorMessage className={"error-message"} />
    </FormWrapper>
  );
}
